var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block overflow-hidden",staticStyle:{"background-color":"rgba(0,0,0,0.1)"}},[_c('div',{staticStyle:{"height":"70%"},style:(_vm.styleObject)})])}
var staticRenderFns = []

export { render, staticRenderFns }